import { Card, Div, FormStatus, H4, Icon, Li, P, Span, Ul } from '@dnb/eufemia';
import { check as CheckIcon, close as CloseIcon } from '@dnb/eufemia/icons';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

import Divider from '@/components/Divider';

import { ApiError, ApiErrorKeys, ApiValidationRequirement, ValidationKey } from '../helpers';

import style from './ValidateSection.module.css';

type ValidateProps = {
  data: ApiValidationRequirement;
  title: string;
  errorKey: ValidationKey;
  errors: ApiError;
  additionalInformation?: ReactNode;
  noFormatSuffix?: boolean;
};

const StyledWarning = styled(FormStatus)`
  & .dnb-form-status__text {
    max-width: 100%;
  }
`;

export function ValidateSection({
  errorKey,
  data,
  title,
  errors,
  additionalInformation,
  noFormatSuffix,
}: ValidateProps) {
  const error = errors[errorKey];

  return (
    <Card bottom="small" stack>
      {Object.keys(data).map((item, index) => {
        return (
          <div className={style['Container']} key={index}>
            <Div bottom="small" className={style['CardRow']}>
              <P>{data[item as ApiErrorKeys]}</P>
              <P>
                <Span right="small">
                  {error && !!error[item as ApiErrorKeys] ? (
                    <Icon className={style['CloseIcon']} icon={<CloseIcon />} />
                  ) : (
                    <Icon className={style['Checkmark']} icon={<CheckIcon />} />
                  )}
                </Span>
                {error && !!error[item as ApiErrorKeys] ? 'No' : 'Yes'}
              </P>
            </Div>
            {Object.keys(data).length !== index + 1 && <Divider />}
          </div>
        );
      })}
      {error && (
        <StyledWarning
          bottom="small"
          size="large"
          state="warning"
          stretch
          text={
            <>
              <H4>
                {title} {noFormatSuffix ? '' : 'format'}
              </H4>
              <Ul>
                {Object.values(errors[errorKey]!).map((value) => (
                  <Li key={value}>{value}</Li>
                ))}
              </Ul>
              {additionalInformation}
            </>
          }
          title={title}
        />
      )}
    </Card>
  );
}
